import { createContext, useContext, useState, useEffect } from 'react';
import { toServiceArray } from '@/utils/seoUtils';

const CompareContext = createContext();

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState([]);

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('vroum_compare');
    if (stored) {
      try {
        setCompareList(JSON.parse(stored));
      } catch (e) {
        console.error('Error loading compare list:', e);
      }
    }
  }, []);

  // Save to localStorage when list changes
  useEffect(() => {
    localStorage.setItem('vroum_compare', JSON.stringify(compareList));
  }, [compareList]);

  const addToCompare = (garage) => {
    if (compareList.length >= 3) {
      return false; // Max 3 garages
    }
    if (compareList.find(g => g.garage_id === garage.garage_id)) {
      return false; // Already in list
    }
    setCompareList([...compareList, {
      garage_id: garage.garage_id,
      name: garage.name,
      slug: garage.slug,
      city: garage.city,
      rating: garage.rating,
      reviews_count: garage.reviews_count,
      phone: garage.phone,
      services: toServiceArray(garage.services),
      tier: garage.tier,
      address: garage.address
    }]);
    return true;
  };

  const removeFromCompare = (garageId) => {
    setCompareList(compareList.filter(g => g.garage_id !== garageId));
  };

  const isInCompare = (garageId) => {
    return compareList.some(g => g.garage_id === garageId);
  };

  const clearCompare = () => {
    setCompareList([]);
  };

  return (
    <CompareContext.Provider value={{
      compareList,
      addToCompare,
      removeFromCompare,
      isInCompare,
      clearCompare,
      canAddMore: compareList.length < 3
    }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
}
